import { ImageWMS } from "ol/source";
import { Image as ImageLayer } from "ol/layer";
import { METERS_PER_UNIT } from "ol/proj";
import { mapActions } from "vuex";
import endpoints from "@/utils/endpoints";


export const geoserverMapMixin = {
  ...mapActions(["fetchImageFromGeoServer"]),

  methods: {
    createObjectsImageLayer(source) {
      return new ImageLayer({
        tileOptions: { crossOrigin: "anonymous" },
        source: source
      });
    },

    createObjectsImageSource() {
      return new ImageWMS({
        url: endpoints.FIBER_API_URL,
        params: {
          LAYERS: this.getActiveLayers(),
          viewparams: this.getViewParameters(),
          CQL_FILTER: this.getCQLFilters(),
          force_workspace_filter: false,
          VERSION: "1.1.1",
          SRS: "EPSG:3857"
        },
        serverType: "geoserver",
        crossOrigin: "anonymous",
        ratio: 1
      });
    },

    getActiveLayers() {
      return "";
    },

    getViewParameters() {
      return null;
    },

    getCQLFilters() {
      return null;
    },

    setGeoserverImageLoadFunction(source, workspaceUUID) {
      source.setImageLoadFunction(
        async (image, src) =>
          await this.loadGeoserverObjectsImage(image, src, workspaceUUID)
      );
    },

    async loadGeoserverObjectsImage(image, src, workspaceUUID) {
      let img = image.getImage();
      let defaultImgSrc =
        "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

      this.loading = true;
      try {
        let response = await this.fetchImageFromGeoServer({
          params: this.getParams(src),
          workspaceUUID: workspaceUUID
        });
        src = this.convertImageFromGeoserver(response);
        if (src) {
          img.src = src;
        } else {
          img.src = defaultImgSrc;
        }
      } catch (e) {
        img.src = defaultImgSrc;
      } finally {
        this.loading = false;
      }
    },

    getParams(src) {
      let urlArray = src.split("?");
      let params = urlArray[1];
      params += "&scale=" + this.getScale(this.mapView);
      return params;
    },

    /** Returns the actual scale of the map **/
    getScale(mapView) {
      let resolution = mapView.getResolution();
      let projection = mapView.getProjection();
      let dpi = 25.4 / 0.28;
      let units = projection.getUnits();
      let mpu = METERS_PER_UNIT[units];
      return resolution * mpu * 39.37 * dpi;
    },

    convertImageFromGeoserver(resp) {
      let type = resp.headers["content-type"];

      if (type.indexOf("image") === 0) {
        let uInt8Array = new Uint8Array(resp.data);
        let charArray = [];
        for (let charCode of uInt8Array) {
          charArray.push(String.fromCharCode(charCode));
        }
        let imageData = charArray.join("");
        imageData = window.btoa(imageData);

        return "data:" + type + ";base64," + imageData;
      }
    },

    updateGeoserver() {
      this.objectsImageSource.updateParams({ time: Date.now() });
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/geoserverMapMixin.js